import { allPetAssets } from '../petAssets';
import { usePrefersReducedMotion } from '../hooks/usePrefersReducedMotion';
import { PINNED_TRACK_LAYOUT, useHorizontalTrack } from '../hooks/useHorizontalTrack';

export function CompanionsSection() {
  const prefersReducedMotion = usePrefersReducedMotion();

  const { sectionRef, trackRef } = useHorizontalTrack<HTMLElement>({
    enabled: !prefersReducedMotion,
    overshoot: 80,
    scrub: 0.85,
    tail: 0.25,
  });

  return (
    <section
      id="companions"
      ref={sectionRef}
      // Pinned, the section is exactly one screen between the page chrome and
      // the call dock, and the pets scale to the height that is left.
      className={`relative overflow-hidden bg-stage text-mist ${prefersReducedMotion ? '' : PINNED_TRACK_LAYOUT}`}
      aria-labelledby="companions-heading"
    >
      <div className="film-grain z-[1]" aria-hidden="true" />
      <div
        className={`relative z-[2] px-[var(--section-padding-x)] ${prefersReducedMotion ? 'pt-[var(--section-padding-y)]' : ''}`}
      >
        <p className="font-body text-xs font-medium uppercase tracking-[0.28em] text-dawn">Waiting room</p>
        <h2
          id="companions-heading"
          className="mt-4 max-w-2xl font-display text-3xl font-semibold leading-[1.02] tracking-tight text-mist sm:text-4xl lg:text-5xl"
        >
          Dogs and cats, side by side
        </h2>
        <p className="mt-5 max-w-lg font-body text-base leading-7 text-white/65">
          A Midrand waiting room mixes breeds and temperaments. Every one of them gets the same unhurried exam.
        </p>
      </div>

      <div
        className={`relative z-[2] ${prefersReducedMotion ? 'pb-[var(--section-padding-y)] pt-10' : 'min-h-0 flex-1 pt-8'}`}
      >
        <div
          ref={trackRef}
          className={`flex items-end px-[var(--section-padding-x)] ${
            prefersReducedMotion ? 'flex-wrap gap-8' : 'h-full w-max gap-0'
          }`}
        >
          {allPetAssets.map((pet, index) => {
            const overlap = prefersReducedMotion ? '' : index === 0 ? '' : '-ml-10 sm:-ml-16';
            const height = index % 3 === 0 ? 'h-[82%]' : index % 3 === 1 ? 'h-full' : 'h-[70%]';

            return (
              <figure
                key={pet.id}
                className={`relative shrink-0 ${overlap} ${
                  prefersReducedMotion ? 'w-36' : 'flex h-full w-[42vw] max-w-[18rem] flex-col justify-end sm:w-64'
                }`}
              >
                <div className={prefersReducedMotion ? '' : 'flex min-h-0 flex-1 items-end'}>
                  <img
                    src={pet.srcSm}
                    alt=""
                    width={pet.width}
                    height={pet.height}
                    className={`w-auto max-w-none object-contain drop-shadow-[0_24px_40px_rgba(0,0,0,0.35)] ${
                      prefersReducedMotion ? 'h-40' : height
                    }`}
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <figcaption className="mt-3 font-body text-xs uppercase tracking-[0.22em] text-white/70">
                  {pet.species} · {String(index + 1).padStart(2, '0')}
                </figcaption>
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
